import classNames from 'classnames';

import CheckmarkInput, { Props as CheckmarkInputProps } from '@components/atoms/CheckmarkInput';

import classes from './Checkbox.module.scss';

export type Props = Omit<CheckmarkInputProps, 'checkmark' | 'type'>;

const Checkbox = ({ checked, error, classes: customClasses, ...rest }: Props): JSX.Element => (
  <CheckmarkInput
    type="checkbox"
    checked={checked}
    error={error}
    classes={customClasses}
    {...rest}
    checkmark={
      <div
        className={classNames(classes.checkmark, customClasses?.checkmark, {
          [classes.checked]: checked,
          [classes.errorCheckmark]: error,
        })}
      />
    }
  />
);

export default Checkbox;
